import React from "react";

export const Kitchen: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg {...props} width="89" height="75" viewBox="0 0 89 75" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M56.0233 15V45H65.0287V75H71.0323V0C62.7473 0 56.0233 8.4 56.0233 15ZM41.0143 26.25H35.0108V0H29.0072V26.25H23.0036V0H17V26.25C17 34.5375 22.3732 41.25 29.0072 41.25V75H35.0108V41.25C41.6447 41.25 47.0179 34.5375 47.0179 26.25V0H41.0143V26.25Z" fill="currentColor"/>
</svg>
);
